import { render, staticRenderFns } from "./AuthenticatePhoneMeliCodeInput.vue?vue&type=template&id=0a3f2b20&scoped=true"
import script from "./AuthenticatePhoneMeliCodeInput.vue?vue&type=script&lang=js"
export * from "./AuthenticatePhoneMeliCodeInput.vue?vue&type=script&lang=js"
import style0 from "./AuthenticatePhoneMeliCodeInput.vue?vue&type=style&index=0&id=0a3f2b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3f2b20",
  null
  
)

export default component.exports